import { useNavigate } from 'react-router-dom';
import { Title } from '../../elements';
import { WeightType } from '../../models/animal';
import { Avatar, Chip, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import SowIco from '../../static/sow01.jpg';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { AnimalFosterMotherHistoryItem } from '../../models/animal-view';
import { renderWeightCellDoubleWeightWithDate } from '../../utils/animalutils';
import { useFarmDateTime } from '../../hooks/useFarmDateTime';

interface AnimalViewFosterMotherHistoryProps {
  history: AnimalFosterMotherHistoryItem[];
  currentFosterMotherId?: string | null;
}

const AnimalViewFosterMotherHistory = ({ history, currentFosterMotherId }: AnimalViewFosterMotherHistoryProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { formatDate, formatTime } = useFarmDateTime();

  const sortedHistory = [...history].sort(
    (a, b) => new Date(b.transferredAt).getTime() - new Date(a.transferredAt).getTime()
  );

  if (sortedHistory.length === 0) {
    return null;
  }

  return (
    <Paper className={classes.paper} elevation={1}>
      <Grid container spacing={1}>
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <Avatar alt="Foster mother history" src={SowIco} />
          </Grid>
          <Grid item>
            <Title>{t('f-foster-history-title')}</Title>
          </Grid>
          <Grid item>
            <Chip className={classes.formControl} label={sortedHistory.length} variant="outlined" />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Table size="small">
            <TableHead>
              <TableRow className={classes.tableHeader}>
                <TableCell>{t('f-foster-transfers-foster-mother')}</TableCell>
                <TableCell>{t('f-foster-transfers-weight')}</TableCell>
                <TableCell>{t('f-com-date')}</TableCell>
                <TableCell>{t('f-com-time')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedHistory.map((entry) => (
                <TableRow key={entry.id} hover>
                  <TableCell>
                    <Chip
                      className={classes.formControl}
                      avatar={<Avatar src={SowIco} />}
                      label={entry.fosterMotherNumber}
                      color="primary"
                      size="small"
                      variant="outlined"
                      onClick={() => navigate(`/animal/${entry.fosterMotherId}`)}
                    />
                    {entry.fosterMotherId === currentFosterMotherId && (
                      <Chip className={classes.formControl} label={t('f-com-current')} color="primary" size="small" />
                    )}
                  </TableCell>
                  <TableCell>
                    {renderWeightCellDoubleWeightWithDate(entry.weightAtTransfer ?? null, WeightType.Kilograms)}
                  </TableCell>
                  <TableCell>{formatDate(entry.transferredAt)}</TableCell>
                  <TableCell>{formatTime(entry.transferredAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AnimalViewFosterMotherHistory;
